import { Select } from "@mantine/core";

export const LAYOUT_VARIANTS = [
  "default",
  "primary",
  "accent",
  "info",
  "success",
  "warning",
  "error",
  "idea",
] as const;

export type LayoutVariant = (typeof LAYOUT_VARIANTS)[number];

const OPTIONS = LAYOUT_VARIANTS.map((v) => ({
  value: v,
  label: v[0].toUpperCase() + v.slice(1),
}));

/**
 * Compact dropdown used inside every "Configure …" modal so the editor can
 * tag chips, items, highlights and footer callouts with a fumadocs color
 * token. Renders nothing visual until expanded — keeps the modals tight.
 */
export function VariantSelect({
  value,
  onChange,
  label = "Variant",
}: {
  value: LayoutVariant;
  onChange: (next: LayoutVariant) => void;
  label?: string;
}) {
  return (
    <Select
      size="xs"
      label={label}
      data={OPTIONS}
      value={value}
      onChange={(v) => onChange((v as LayoutVariant) ?? "default")}
      allowDeselect={false}
      withCheckIcon={false}
    />
  );
}
